<template>
  <vi-dialog
    :class="`${name}-container`"
    :visible.sync="showUploadError"
    :width="`60%`"
    :height="`45vh`"
    :z-index="3000"
  >
    <img :class="`${name}-container_icon`" src="@/assets/images/warning.png" alt=" " />
    <div :class="`${name}-container_tips`">{{ $t('material_duration') }}</div>
    <vi-button :style="{ width: '100%', fontSize: '16px' }" type="primary" @click="handleClick">
      {{ $t('home_btn_ok') }}
    </vi-button>
  </vi-dialog>
</template>
<script>
import { computed, defineComponent } from 'vue-demi';
import adsCreative from '@/store/modules/ads_creative';
const name = 'upload-failed-dialog';
export default defineComponent({
  name,
  components: {},
  props: {},
  setup() {
    const showUploadError = computed(() => adsCreative.getters.general.value.videoUploadFailed);
    const handleClick = () => {
      adsCreative.mutations.setVideoUploadFailed(false);
    };
    return {
      name,
      handleClick,
      showUploadError,
    };
  },
});
</script>
<style lang="scss">
.upload-failed-dialog {
  &-container {
    display: flex;
    flex-direction: column;
    &_tips {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
    &_icon {
      position: relative;
      height: 80px;
      width: 80px;
      left: 50%;
      transform: translateX(-50px);
    }
  }
}
</style>
